import styled from 'styled-components';

import { GroupSelect } from 'ui/indexPages/tables/groupSelect';
import { DiamondLogo } from 'ui/logo';
import { colors, spacing } from 'ui/theme';
import { button } from 'ui/theme/typography';
import { pxToRem } from 'utils/convert';

export const HeaderButton = styled.button`
  ${button}
  background: none;
  border: none;
  padding: ${spacing.half} 0;
  outline: none;

  span {
    display: inline-block;
    margin-right: ${spacing.quarter};
  }
`;

type ImageWrapperProps = {
  isEmptyState?: boolean;
};
export const ImageWrapper = styled.div`
  align-items: center;
  border: solid ${spacing.single} rgb(0 0 0 / 0.05);
  border-radius: ${pxToRem(6)};
  display: flex;
  height: 50px;
  width: 60px;
  justify-content: center;
  overflow: hidden;
  position: relative;

  ::after {
    background: ${(props: ImageWrapperProps): string =>
      props.isEmptyState ? colors.white : colors.grey5};
    inset: 7% 8%;
    border-radius: ${spacing.quarter};
    content: '';
    display: block;
    position: absolute;
    z-index: 1;
  }

  > * {
    position: relative;
    z-index: 2;
  }
`;

export const PreviewImg = styled.img`
  display: block;
  height: 100%;
  width: 100%;
`;

export const StyledGroupSelect = styled(GroupSelect)`
  margin-left: -${pxToRem(9)};
`;

export const StyledLogo = styled(DiamondLogo)`
  opacity: 30%;
  && {
    background: ${colors.white};
  }
`;
